module.exports = __webpack_public_path__ + "media/invite/view-63c472ff.svg";